import { useMemo } from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import { getValidationRules, getValidationPropNames } from '../utils/validation';
import { useValidator } from './useValidator';
const mapStateToProps = (state)=>{
    return {
        whitelist: state.validation?.whitelist,
        blacklist: state.validation?.blacklist
    };
};
export const useRegvarValidator = ()=>{
    const { whitelist, blacklist } = useSelector(mapStateToProps, shallowEqual);
    const validator = useValidator();
    return useMemo(()=>{
        return {
            validate (value, props, regvarMetadata) {
                const rules = getValidationRules(props, regvarMetadata, {
                    whitelist,
                    blacklist,
                    validator
                });
                return validator.validate(value, rules);
            },
            getValidationPropNames (validRules = []) {
                return getValidationPropNames(validRules, {
                    validator
                });
            }
        };
    }, [
        whitelist,
        blacklist,
        validator
    ]);
};
